export const escapeCsvCell = (value) => {
    if (value === null || value === undefined) {
        return '';
    }
    const stringValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
    if (/[",\n\r]/.test(stringValue)) {
        return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
};

export const buildCsv = (headers, rows) => {
    const headerLine = headers.map(escapeCsvCell).join(',');
    const dataLines = rows.map((row) => row.map(escapeCsvCell).join(','));
    return `\uFEFF${[headerLine, ...dataLines].join('\n')}`;
};

export const downloadCsvFile = (filename, csvContent) => {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
};

export const getLocalizedName = (names, locale) => {
    const entry = (names || []).find((item) => item.locale === locale);
    return entry?.name || '';
};

export const formatFormLinks = (forms) => (forms || []).map((form) => {
    const code = form.productForm || form.formCode || '';
    const type = form.formType || '';
    const group = form.formGroup || '';
    return `${code}:${type}:${group}`;
}).join(';');

export const formatPropertyForms = (forms) => (forms || []).map((form) => {
    const code = form.productForm || '';
    const included = form.included === false ? 'false' : 'true';
    return `${code}:${included}`;
}).join(';');

export const formatPropertyReferenceBook = (property) => {
    const code = property?.referenceBookCode || '';
    const id = property?.referenceBookId || '';
    if (!code && !id) {
        return '';
    }
    return code || id;
};

export const formatPropertyValue = (value) => {
    if (value === null || value === undefined) {
        return '';
    }
    if (Array.isArray(value)) {
        return JSON.stringify(value);
    }
    return value;
};
